import TextViewer from "../../components/TextViever";

const Message = () => {
  return <TextViewer obszar="message" />;
};

export default Message;
